<mat-toolbar class="square" fxLayout="row" fxLayoutAlign="center center">
  <div fxHide.lt-md fxFlex="8">
    <span>{{ 'Build Number: ' + currentversion }}</span>
  </div>
  <div fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="20px" fxFlex="80">
    <span>
      <a href="https://www.teranet.ca/" id="lnk_visit_terenat" target="_blank" i18n="@@footer_visit_teranet">Visit
        Teranet</a>
    </span>
    <span>
      <a [routerLink]="" id="lnk_contact" (click)="openDialog()" i18n="@@footer_contact_us">Contact Us</a>
    </span>
    <span>
      <a href="#/termandcondition" id="lnk_terms" target="_blank" i18n="@@footer_term_condition">Terms And
        Conditions</a>
    </span>
    <span>
      <a i18n-href="@@footer_href_privacy_policy"
        href="https://www.teranet.ca/about-teranet/legal-notice-and-security-statement/" id="lnk_privacy"
        target="_blank" i18n="@@footer_privacy_policy">Privacy Policy</a>
    </span>
    <span>
      <a i18n-href="@@footer_href_aoda"
        href="https://www.teranet.ca/about-teranet/accessible-customer-service-policy-and-procedure/" id="lnk_aoda"
        target="_blank" i18n="@@footer_aoda">AODA</a>
    </span>
  </div>
  <div fxHide.lt-md fxLayoutAlign="center center">
    <a href="https://www.teranet.ca/" target="_blank">
      <img src="../../../../assets/images/logo/TeranetLogoWhiteTransparent(250x70).png" title="Teranet"
        alt="Teranet" width="250" height="70">
    </a>
  </div>
</mat-toolbar>